import {
  PageRootTypes,
  PageSource,
} from 'shared/constants/dataLayer';
import { PageLocationType } from 'shared/store/categoryListing/types';


interface PageLocationProps {
  root?: string;
  categoryId: string;
  suggestionType?: string;
};

export const getPageLocation = (props: PageLocationProps): PageLocationType => {
  const { root, categoryId, suggestionType } = props;
  let pageLocation = {};
  if (root?.indexOf(PageRootTypes.SEARCH) > -1) {
      pageLocation = {
        pageType: PageSource.SEARCH,
        listingPageType: suggestionType || PageSource.QUERY,
        id:  categoryId,
      };
      return pageLocation;
    }
    else if (root?.indexOf(PageRootTypes.OFFER_PDP) > -1) {
      pageLocation = {
        pageType: PageSource.OFFER_PAGE,
        listingPageType: suggestionType,
        id:  categoryId,
      };
      return pageLocation;
    }
    pageLocation = {
        pageType: PageSource.CATEGORY,
        listingPageType: suggestionType,
        id:  categoryId,
      };
  return pageLocation;
};
